import PrintSheet, { SheetField, SheetTitle, TD, TH } from "@/modules/print/sheet";
import { QUOTE_TEMPLATE_HEADERS } from "@buildpy/core/modules/tools/quote-template";

// 손으로 채우는 빈 견적서 — 열은 엑셀 양식과 같은 순서에 금액 칸만 더한다.
export const BLANK_QUOTE_ROWS = 22;

const COLUMNS = [...QUOTE_TEMPLATE_HEADERS.slice(0, 8), "금액", QUOTE_TEMPLATE_HEADERS[8]];
const WIDE = new Set(["작업내역", "비고"]);

const TOTALS = ["공급가액", "부가세 (10%)", "합계 (부가세 포함)"];

const BlankQuoteForm = () => (
  <PrintSheet>
    <SheetTitle>견 적 서</SheetTitle>
    <div className="mb-4 grid grid-cols-2 gap-x-4 border-t border-[#d9d9d9]">
      <SheetField label="현장명">{" "}</SheetField>
      <SheetField label="견적일">{" "}</SheetField>
      <SheetField label="고객명">{" "}</SheetField>
      <SheetField label="시공사">{" "}</SheetField>
      <SheetField label="공사기간">{" "}</SheetField>
      <SheetField label="연락처">{" "}</SheetField>
    </div>
    <table className="w-full table-fixed border-collapse" data-testid="blank-quote-table">
      <thead>
        <tr>
          {COLUMNS.map((label) => (
            <TH key={label} className={WIDE.has(label) ? "w-[18%]" : undefined}>
              {label}
            </TH>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: BLANK_QUOTE_ROWS }, (_, i) => (
          <tr key={i} className="h-7">
            {COLUMNS.map((label) => (
              <TD key={label} />
            ))}
          </tr>
        ))}
        {TOTALS.map((label) => (
          <tr key={label} className="h-7">
            <TD className="bg-[#fafafa] text-right font-semibold" colSpan={COLUMNS.length - 2}>
              {label}
            </TD>
            <TD colSpan={2} />
          </tr>
        ))}
      </tbody>
    </table>
    <p className="mt-3 text-[10px] leading-4 text-[#525252]">
      금액 = 수량 × (자재 단가 + 노무 단가). 엑셀 양식에 옮겨 적으면 buildpy 견적으로 바로 가져올 수 있습니다.
    </p>
  </PrintSheet>
);

export default BlankQuoteForm;
